import React, { FormHTMLAttributes } from 'react';
import styled from 'styled-components';

export const FormFields: React.FunctionComponent<FormHTMLAttributes<HTMLFormElement>> = (props) => (
  <Form {...props} />
);

const Form = styled.form`
  width: 100%;
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/components/form/form-fields.component.tsx